export default __webpack_public_path__ + "img/54.e504b90.svg";